
import Vue from 'vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  required, confirmed, regex,
} from 'vee-validate/dist/rules';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import BackgroundImage from '@/components/BackgroundImage/index.vue';
import Button from '@/components/Button/index.vue';
import Card from '@/components/Card/index.vue';
import Checkbox from '@/components/Checkbox/index.vue';
import Heading from '@/components/Heading/index.vue';
import IconEmail from '@/components/Icons/Email/index.vue';
// import IconWhatsApp from '@/components/Icons/WhatsApp/index.vue';
import IconPaste from '@/components/Icons/Paste/index.vue';
import Tooltip from '@/components/Tooltip/index.vue';
// import IconTelegram from '@/components/Icons/Telegram/index.vue';
import Input from '@/components/InputWithValidation/index.vue';
import InputForm from '@/components/InputWithValidationForm/index.vue';
import LogoAgrotools from '@/components/Logos/Agrotools/index.vue';
import LogoPrincipal from '@/components/Logos/Principal/index.vue';
import LogoPrograma from '@/components/Logos/Programa/index.vue';
import Modal from '@/components/Modal/index.vue';
import RadioButton from '@/components/RadioButton/index.vue';
import { ProdInfo } from '@/config/types';
import {
  formatStringOnlyNumbers, isBayer, isValidLanguage, removeMaskDocument, compareValeus,
} from '@/utils';
import { getOneByCodeVoucher } from '@/services/voucher/get-one-by-code-voucher';
import createUserService from '@/services/user/create-user';
import {
  CreateErrorMessage,
  ClickableColumn,
  ProfileSelector,
  TextRegistered,
  TextArea,
  TextAlignedLeft,
  TelegramWrapper,
  Row,
  WrapperButton,
  WrapperInput,
  WrapperMain,
} from './styles';

export default Vue.extend({
  components: {
    BackgroundImage,
    Button,
    Card,
    CreateErrorMessage,
    Checkbox,
    ClickableColumn,
    Heading,
    IconEmail,
    // IconWhatsApp,
    IconPaste,
    Tooltip,
    // IconTelegram,
    Input,
    LogoAgrotools,
    LogoPrincipal,
    LogoPrograma,
    Modal,
    ProfileSelector,
    RadioButton,
    Row,
    ValidationObserver,
    ValidationProvider,
    TextRegistered,
    TelegramWrapper,
    TextAlignedLeft,
    TextArea,
    WrapperButton,
    WrapperInput,
    WrapperMain,
    InputForm,
  },
  data() {
    return {
      isBayer: false,
      isBayerArg: false,
      isLoading: false,
      isLoadingEnd: false,
      voucherData: {} as any,
      currentStep: 1,
      registerType: 'prod',
      zipCodeCep: '',
      erroStatus: false,
      isOpenModal: true,
      document: {
        'pt-BR': {
          label: 'CPF/CNPJ',
          mask: ['###.###.###-##', '##.###.###/####-##'],
          maskcep: ['##.###-###', '##.###-###'],
        },
        'es-AR': {
          label: 'CUIT',
          mask: ['##-########-#'],
        },
      },
      objAdress: {} as any,
      prod: {
        name: '',
        document: '',
        email: '',
        phone: '',
        password: '',
        terms: '',
        voucher: '',
        lang: '',
        address: {
          tokenKey: '',
          cdAgent: '',
          cdUser: '',
          address: '',
          number: '',
          neighborhood: '',
          complement: 'Casa',
          city: '',
          state: '',
          zipCode: '',
        },
      } as ProdInfo,
      passwordConfirm: '',
      createError: false,
      createErrorMessage: '',
      modalConfirmationVisible: false,
      telegramModalConfirmationVisible: false,
      number: '',
      sendMessageLink: '',
      registrationMessage: '',
      loading: false,
      tooltip: false,
      isProduction: !process.env.VUE_APP_APPLICATION_DNS?.toString().includes('test')
                 && !process.env.VUE_APP_APPLICATION_DNS?.toString().includes('homolog'),
    };
  },
  methods: {
    radioButtonChange(event: string) {
      this.registerType = String(event);
    },
    checkboxChange(event: HTMLInputElement) {
      if (event.checked) this.prod.terms = 'S';
      else this.prod.terms = '';
    },
    updateCity(event) {
      this.prod.address.city = event.target.value.replace(/'/g, '');
    },
    async validVoucher() {
      const voucher = this.prod.voucher as string;
      if (this.isProduction) {
        this.voucherData = await getOneByCodeVoucher({ tokenKey: 'VwU3tdOj5e5eOj4Je5oDCw==', codeVoucher: voucher });
      } else {
        this.voucherData = await getOneByCodeVoucher({ tokenKey: 'nF3K9Vry9z3nNDwSYxxRKw==', codeVoucher: voucher });
      }
      if (this.voucherData.hasErrors) {
        this.createError = true;
        this.createErrorMessage = this.voucherData.error || this.voucherData.message;

        return true;
      }

      if (!this.voucherData?.document) {
        this.createError = true;
        this.createErrorMessage = 'Voucher não encontrado';
        this.isLoading = false;
      }

      const voucherResp = removeMaskDocument(this.voucherData.document);
      const voucherInput = removeMaskDocument(this.prod.document);
      const isEqualDocument = compareValeus(voucherResp, voucherInput);

      if (!isEqualDocument) {
        this.createError = true;
        this.createErrorMessage = 'Voucher não encontrado';
        this.isLoading = false;
        return true;
      }

      if (!this.voucherData.status) {
        this.createError = true;
        this.createErrorMessage = 'Voucher expirado';
        this.isLoading = false;
        return true;
      }

      return false;
    },
    async onSubmit() {
      this.isLoading = true;

      if (this.currentStep === 1 && (await this.validVoucher())) {
        this.isLoading = false;
        return;
      }

      if (this.currentStep === 3) {
        this.createError = false;
        this.createErrorMessage = '';

        this.loading = true;

        if (this.$i18n.locale === 'es-AR' === false) {
          if (formatStringOnlyNumbers(this.prod.document).length <= 11) {
            const isCpfValid = cpf.isValid(formatStringOnlyNumbers(this.prod.document));
            if (!isCpfValid) this.createError = true; this.createErrorMessage = 'CPF Inválido'; this.currentStep = 1;
          } else {
            const isCnpjValid = cnpj.isValid(formatStringOnlyNumbers(this.prod.document));
            if (!isCnpjValid) this.createError = true; this.createErrorMessage = 'CNPJ Inválido'; this.currentStep = 1;
          }
        }
        if (this.erroStatus === false) {
          this.isLoadingEnd = true;
          const response = await createUserService(process.env.VUE_APP_TOKEN !== undefined ? process.env.VUE_APP_TOKEN.toString() : '', {
            name: this.prod.name,
            document: formatStringOnlyNumbers(this.prod.document),
            email: this.prod.email,
            phone: formatStringOnlyNumbers(this.prod.phone),
            terms: this.prod.terms,
            lang: this.$i18n.locale,
            password: this.prod.password,
            address: {
              tokenKey: this.isProduction === true ? 'VwU3tdOj5e5eOj4Je5oDCw==' : 'nF3K9Vry9z3nNDwSYxxRKw==',
              cdAgent: '0',
              cdUser: '0',
              address: this.prod.address.address,
              number: this.prod.address.number,
              neighborhood: this.prod.address.neighborhood,
              complement: this.prod.address.complement,
              city: this.prod.address.city,
              state: this.prod.address.state,
              zipCode: this.prod.address.zipCode,
            },
          });
          this.loading = false;
          this.isLoading = false;
          if (response.message === 'E-mail já cadastrado') {
            this.loading = false;
            this.isLoading = false;
          }
          if (!response) {
            this.currentStep = 1;
            this.createError = true;
            this.createErrorMessage = 'Aconteceu um erro, tente novamente.';

            return;
          }

          if (response.hasErrors === true) {
            this.createError = true;

            const { message } = response;
            this.createErrorMessage = message;

            const hasSenha = message.includes('senha');
            const hasNumber = message.match(/^\d/);
            if (!hasSenha) {
              this.currentStep = 1;
            }

            if (hasNumber) {
              this.createErrorMessage = '';
            }
            return;
          }
          this.sendMessageLink = `https://api.whatsapp.com/send?phone=55${formatStringOnlyNumbers(
            this.number,
          )}?&text=Ol%C3%A1%2C%20sou%20produtor%20rural%2C%20meu%20nome%20%C3%A9%3A%20${this.prod.name}%2C%20meu%20documento%20%C3%A9%3A%20${this.prod.document}%2C%20e%20fiz%20meu%20cadastro%20pelo%20portal!`;

          this.registrationMessage = `Olá, sou produtor rural, meu nome é: ${this.prod.name}, meu documento é: ${this.prod.document}, e fiz meu cadastro pelo portal!`;
          this.modalConfirmationVisible = true;

          return;
        }
        Vue.swal('', 'CEP Invalido', 'error');
        this.isBayer = false;
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      this.createError = false;
      this.createErrorMessage = '';
      this.currentStep += 1;
    },
    async searchZipCode(valor: string) {
      const cep = valor.replace(/\D/g, '');
      if (cep !== '') {
        const validacep = /^[0-9]{8}$/;
        if (validacep.test(cep)) {
          const requestOptions = {
            method: 'GET',
            redirect: 'follow',
          } as any;
          fetch(`https://viacep.com.br/ws/${cep}/json/`, requestOptions)
            .then((response) => response.json())
            .then((result) => { this.objAdress = result; })
            .catch((error) => console.log('error', error));
          if (this.objAdress.erro) {
            this.erroStatus = this.objAdress.erro;
          } else {
            this.erroStatus = false;
            this.prod.address.state = this.objAdress.uf;
            this.prod.address.city = this.objAdress.localidade;
            this.prod.address.neighborhood = this.objAdress.bairro;
            this.prod.address.address = this.objAdress.logradouro;
          }
        }
      }
    },
    goToLogin() {
      this.$router.replace('/login');
    },
    goToTelegram() {
      window.open('https://t.me/atendentePREM_bot', '_blank');
    },
    copy() {
      ((this.$refs.clone as Vue).$el as HTMLElement).focus();
      document.execCommand('copy');
    },
  },
  created() {
    const { lang } = this.$route.query;
    if (isValidLanguage(lang as string)) {
      sessionStorage.setItem('language', lang as string);
      this.$i18n.locale = lang as string;
    }
    console.log(this.$refs);
  },
  watch: {
    zipCodeCep(val) {
      if (val.length === 10) {
        this.prod.address.zipCode = val;
        if (this.prod.address.zipCode.length === 10) {
          this.searchZipCode(this.prod.address.zipCode);
        }
      }
      console.log(val);
    },
    'prod.address.city': function sanitizeCity(newValue) { // Nomeando a função
      if (newValue) {
        this.prod.address.city = newValue.replace(/'/g, '');
      }
    },
  },
  mounted() {
    this.isBayer = isBayer();
    this.isBayerArg = isBayer() && this.$i18n.locale === 'es-AR';
    this.number = process.env.VUE_APP_WHATS_NUMBER || '';
    extend('required', {
      ...required,
      message: this.$t('required_field', { field: this.$t('password') }) as string,
    });

    extend('regex', {
      ...regex,
      message: this.$t('password_rules') as string,
    });

    extend('confirmed', {
      ...confirmed,
      message: this.$t('password_confirm_error') as string,
    });
  },
});
